// @flow
import React, { Component } from 'react';
import Server from './Server.js';
import Cell from './Cell.js';
import PrintButton from './PrintButton.js';
import HelpButton from './HelpButton.js';
import Clues from './Clues.js';
import Loading from './Loading.js';
import { MobileKeyboard, MobileKeyboardButton } from './MobileKeyboard.js';
import {TimerState, Timer} from './Timer.js';
import { Route, Switch, Redirect } from 'react-router-dom';
import { ButtonToolbar, Button, ButtonGroup, Modal, OverlayTrigger, Tooltip } from 'react-bootstrap';
import Card from 'react-bootstrap/Card'
import Accordion from 'react-bootstrap/Accordion'
import DropdownButton from 'react-bootstrap/DropdownButton'
import Dropdown from 'react-bootstrap/Dropdown'
import scrollIntoViewIfNeeded from 'scroll-into-view-if-needed';
import i18n from './Localization';
import getQueryParams from './GetQueryParams';
import formatDateYYMMDD from './DateTimeHelpers';
import Layout from './Layout.js';


var Acpt = require('./acpt.js');

export const TOOLTIP_DELAY = 700

class XwordClue {
  state: {
    index: number,
    direction: string,
    number: number,
    clue: string,
    answer: string,
    active: boolean,
    crossActive: boolean
  };

  constructor(options) {
    this.state = {
      'index': 0,
      'direction': 'A',
      'number': 0,
      'clue': '',
      'answer': '',
      'active': false,
      'crossActive': false,
    };
    Object.assign(this.state, options);
  }
  setState(newstate) {
    Object.assign(this.state, newstate);
  }
  get(key) : any {
    return this.state[key];
  }
}

class XwordCell {
  state: {
    fill: string,
    entry: string,
    active: boolean,
    focus: boolean,
    circled: boolean,
    greyed: boolean,
    incorrect: boolean,
    hidden: boolean,
    number: number,
    version: number,
  };

  constructor(options) {
    this.state = {
      fill: '.',
      entry: ' ',
      active: false,
      focus: false,
      circled: false,
      greyed: false,
      hidden: false,
      incorrect: false,
      version: 0,
      number: 0,
    };
    Object.assign(this.state, options);
  }
  setState(newstate) {
    Object.assign(this.state, newstate);
  }
  get(key) : any {
    return this.state[key];
  }
  isBlack() : boolean {
    return this.state.fill === '#';
  }
}

function Title(props) {
  var title = props.title;
  var author = props.author ? i18n.t("mainAuthor", { author: props.author }) : "";

  return (
      <div className={"xwordjs-title"}>
        <span className={"xwordjs-title-text"}>{title}</span>
        <span className={"xwordjs-author-text"}>{author}</span>
      </div>
  );
}

function ClueBar(props) {
  var text = '';
  for (var i=0; i < props.value.length; i++) {
    var clue = props.value[i];
    if (clue.get('active')) {
      text = clue.get('number') + ". " + clue.get('clue');
    }
  }
  return <div className={"xwordjs-clue-bar"}>{text}</div>;
}

class Grid extends Component {
  render() {
    var rows = [];
    for (var i=0; i < this.props.height; i++) {
      var row_cells = [];
      for (var j=0; j < this.props.width; j++) {
        var ind = i * this.props.width + j;
        var cell = this.props.cells[ind];
        var above;
        if (i > 0) {
          var aind = (i - 1) * this.props.width + j;
          above = this.props.cells[aind];
        }
        var right;
        if (j > 0) {
          var rind = i * this.props.width + (j - 1);
          right = this.props.cells[rind];
        }

        var fill = cell.get('fill');
        var entry = cell.get('entry');
        var active = cell.get('active');
        var focus = cell.get('focus');
        var circled = cell.get('circled');
        var greyed = cell.get('greyed');
        var hidden = cell.get('hidden');
        var incorrect = cell.get('incorrect');
        var number = cell.get('number') || '';
        var black = fill === '#';

        var isTop = i === 0 || (above && above.get('hidden'));
        var isLeft = j === 0 || (right && right.get('hidden'));

        if (fill === '#' || fill === '.') {
          fill = ' ';
        }
        var cell_item = <Cell id={"cell_" + ind} value={entry} key={"cell_" + ind}
         isBlack={black} isActive={active} isFocus={focus}
         isCircled={circled}
         isGreyed={greyed}
         isHidden={hidden}
         isIncorrect={incorrect}
         isTop={isTop} isLeft={isLeft} number={number}
         onClick={(x) => this.props.handleClick(parseInt(x.substring(5), 10))}/>;
        row_cells.push(cell_item);
      }
      rows[i] = <div className="xwordjs-grid-row" key={"row_" + i}>{row_cells}</div>;
    }
    return (
      <div id="xwordjs-grid-inner">{rows}</div>
    );
  }
}

class XwordSolver extends Component {

  state: {
    height: number,
    width: number,
    cells: Array<XwordCell>,
    clues: Array<XwordClue>,
    title: string,
    author: string,
    timer: TimerState,
    activecell: number,
    direction: string,
    cell_to_clue_table: Array<Array<number>>,
    clue_to_cell_table: Array<number>,
    version: number,
    solutionId: ?string,
    modified: boolean,
    show_keyboard: boolean,
    show_numeric_keys: boolean,
    server: Server,
    available_puzzles: Array<string>,
    reveal_opt: string,
    rebus: boolean,
    puzzle_id: string,
    notes: ?string,
    show_completed: boolean,
    reset_prompt: boolean,
  };
  onKeyDown: Function;
  onResize: Function;
  revealAll: Function;

  constructor() {
    super();
    this.state = {
      width: Layout.gridWidth,
      height: Layout.gridHeight,
      cells: [],
      clues: [],
      title: '',
      author: '',
      timer: new TimerState(),
      activecell: 0,
      direction: 'A',
      cell_to_clue_table: [],
      clue_to_cell_table: [],
      version: 1,
      modified: false,
      show_dates_dropdown: process.env.REACT_APP_ENABLE_DATES_DROPDOWN ? process.env.REACT_APP_ENABLE_DATES_DROPDOWN.toLowerCase() === 'true' : true,
      show_keyboard: false,
      show_numeric_keys: false,
      solutionId: null,
      server: new Server(),
      available_puzzles: [],
      reveal_opt: 'letter',
      puzzle_id: '',
      rebus: false,
      notes: null,
      show_completed: false,
      reset_prompt: false,
      isDropdownXwordPuzzleListOpen: false,
      isRevealTypeOpen: false,
    }
    this.onKeyDown = this.handleKeyDown.bind(this);
    this.onResize = this.resizeScrollPane.bind(this);
    this.revealAll = this.revealAll.bind(this);

    this.xwordPuzzleListDropdownRef = React.createRef();
    this.printButtonRef = React.createRef();
    this.helpButtonRef = React.createRef();
    this.timerButtonRef = React.createRef();
  }
  loadServerPuzzle(id: string) {
    var self = this;
    this.state.server.getPuzzle(id)
      .then(function (data) {
        var puz = new Acpt(data);
        if (process.env.REACT_APP_GRID_DYNAMIC?.toLowerCase() === "true") {
          if (Number.isInteger(puz?.width)) {
            Layout.gridWidth = puz.width
          }
          if (Number.isInteger(puz?.height)) {
            Layout.gridHeight = puz.height
          }
        }
        self.puzzleLoaded(id, puz);
      });
  }
  cellPos(cell_id: number) {
    var y = Math.floor(cell_id / this.state.width);
    var x = cell_id % this.state.width;
    return [x, y];
  }
  cellBounds(cell_id: number, dind: number) {
    var clue_id = this.state.cell_to_clue_table[cell_id][dind];
    var start_cell_id = this.state.clue_to_cell_table[clue_id];

    var clue = this.state.clues[clue_id];
    var alen = clue.get('answer').length;

    var [x, y] = this.cellPos(start_cell_id);
    var [x_incr, y_incr] = [(1 - dind), dind];
    var [end_x, end_y] = [x + x_incr * (alen - 1), y + y_incr * (alen - 1)];
    var end_cell_id = this.state.width * end_y + end_x;

    return [start_cell_id, end_cell_id];
  }
  navRight() {
    var [x, y] = this.cellPos(this.state.activecell);
    while (x < this.state.width) {
      x += 1;
      if (x < this.state.width &&
          this.state.cells[y * this.state.width + x].get('fill') !== '#')
        break;
    }
    if (x === this.state.width)
      return;

    var activecell = y * this.state.width + x;
    this.selectCell(activecell, this.state.direction);
  }
  navStart() {
    var [start_cell_id, _] = this.cellBounds(this.state.activecell,
      this.state.direction === 'A' ? 0 : 1);
    this.selectCell(start_cell_id, this.state.direction);
  }
  navEnd() {
    var [_, end_cell_id] = this.cellBounds(this.state.activecell,
      this.state.direction === 'A' ? 0 : 1);
    this.selectCell(end_cell_id, this.state.direction);
  }
  navLeft() {
    var [x, y] = this.cellPos(this.state.activecell);
    while (x >= 0) {
      x -= 1;
      if (x >= 0 &&
          this.state.cells[y * this.state.width + x].get('fill') !== '#')
        break;
    }
    if (x < 0)
      return;

    var activecell = y * this.state.width + x;
    this.selectCell(activecell, this.state.direction);
  }
  navUp() {
    var [x, y] = this.cellPos(this.state.activecell);
    while (y >= 0) {
      y -= 1;
      if (y >= 0 &&
          this.state.cells[y * this.state.width + x].get('fill') !== '#')
        break;
    }
    if (y < 0)
      return;
    var activecell = y * this.state.width + x;
    this.selectCell(activecell, this.state.direction);
  }
  navDown() {
    var [x, y] = this.cellPos(this.state.activecell);
    while (y < this.state.height) {
      y += 1;
      if (y < this.state.height &&
          this.state.cells[y * this.state.width + x].get('fill') !== '#')
        break;
    }
    if (y === this.state.height)
      return;

    var activecell = y * this.state.width + x;
    this.selectCell(activecell, this.state.direction);
  }
  navNextClue() {
    var dind = (this.state.direction === 'A') ? 0 : 1;
    var cur_cell_id = this.state.activecell;
    var clue_id = this.state.cell_to_clue_table[cur_cell_id][dind];
    var next_clue_id = (clue_id + 1) % this.state.clues.length;
    this.selectClue(this.state.clues[next_clue_id]);
  }
  navPrevClue() {
    var dind = (this.state.direction === 'A') ? 0 : 1;
    var cur_cell_id = this.state.activecell;
    var clue_id = this.state.cell_to_clue_table[cur_cell_id][dind];
    var next_clue_id = (clue_id - 1) % this.state.clues.length;
    this.selectClue(this.state.clues[next_clue_id]);
  }
  findNextEmptyCell(direction: string,
                    start_x: number, start_y: number,
                    end_x: ?number, end_y: ?number): ?number {
    var dind = (direction === 'A') ? 0 : 1;
    var [x_incr, y_incr] = [1 - dind, dind];
    var [x, y] = [start_x, start_y];

    if (end_x === null || end_x === undefined)
      end_x = this.state.width;
    if (end_y === null || end_y === undefined)
      end_y = this.state.height;

    var len = (!dind) ? end_x - start_x : end_y - start_y;
    for (let i = 0; i < len; i++) {
      var cell_id = y * this.state.width + x;
      var cell = this.state.cells[cell_id];

      if (cell.isBlack())
        break;

      if (cell.get('entry') === ' ')
        return cell_id;

      x += x_incr;
      y += y_incr;
    }
    return null;
  }
  navNext() {
    var dind = (this.state.direction === 'A') ? 0 : 1;
    var cur_cell_id = this.state.activecell;
    var clue_id = this.state.cell_to_clue_table[cur_cell_id][dind];
    var start_cell_id = this.state.clue_to_cell_table[clue_id];
    var clue = this.state.clues[clue_id];

    var [x, y] = this.cellPos(cur_cell_id);
    var [start_x, start_y] = this.cellPos(start_cell_id);
    var alen = clue.get('answer').length;

    var empty_cell_id = this.findNextEmptyCell(this.state.direction, x, y);
    // wrap
    if (empty_cell_id === null || empty_cell_id === undefined) {
      empty_cell_id = this.findNextEmptyCell(this.state.direction,
                                             start_x, start_y, x, y);
    }
    if (empty_cell_id === null || empty_cell_id === undefined) {
      // no empty square.
      [x, y] = this.cellPos(cur_cell_id);

      // if end of word, stop
      if ((this.state.direction === 'A' && x === start_x + alen - 1) ||
          (this.state.direction === 'D' && y === start_y + alen - 1)) {
        return;
      }

      // go to next square
      if (this.state.direction === 'A')
        x += 1;
      else
        y += 1;

      empty_cell_id = y * this.state.width + x;
    }
    this.selectCell(empty_cell_id, this.state.direction);
  }
  navPrev() {
    var dind = (this.state.direction === 'A') ? 0 : 1;
    var cur_cell_id = this.state.activecell;
    var clue_id = this.state.cell_to_clue_table[cur_cell_id][dind];
    var start_cell_id = this.state.clue_to_cell_table[clue_id];

    var [x, y] = this.cellPos(cur_cell_id);
    var [start_x, start_y] = this.cellPos(start_cell_id);

    if (this.state.direction === 'A')
      x -= 1;
    else
      y -= 1;
    if (x < start_x)
      x = start_x;
    if (y < start_y)
      y = start_y;

    var activecell = y * this.state.width + x;
    this.selectCell(activecell, this.state.direction);
  }
  switchDir() {
    var dir = this.state.direction === 'A' ? 'D' : 'A';
    this.selectCell(this.state.activecell, dir);
  }
  type(ch: string) {
    var cell = this.state.cells[this.state.activecell];

    if (this.state.rebus) {
      var text = cell.get('entry');
      cell.setState({entry: text + ch});
      this.setState({modified: true})
    } else {
      cell.setState({'entry': ch, 'version': cell.get('version') + 1});
      this.setState({modified: true})
      this.navNext();
    }
  }
  del() {
    var cell = this.state.cells[this.state.activecell];

    if (this.state.rebus) {
      var text = cell.get('entry');
      text = text.substr(0, text.length - 1);
      cell.setState({entry: text});
      this.setState({modified: true})
    } else {
      cell.setState({'entry': ' ', 'version': cell.get('version') + 1});
      this.setState({modified: true})
      this.selectCell(this.state.activecell, this.state.direction);
    }
  }
  print(id: string, type: number) {
    window.open(this.state.server.getPrintUrl(id, type));
  }
  backspace() {
    var cell = this.state.cells[this.state.activecell];

    if (this.state.rebus) {
      var text = cell.get('entry');
      text = text.substr(0, text.length - 1);
      cell.setState({entry: text});
      this.setState({modified: true})
    } else if (cell.get('entry') == ' ') {
      // if this cell is blank, delete the previous contents
      this.navPrev();
      cell = this.state.cells[this.state.activecell];
      cell.setState({entry: ' '});
      this.setState({modified: true});
    } else {
      cell.setState({'entry': ' ', 'version': cell.get('version') + 1});
      this.setState({modified: true})
      this.navPrev();
    }
  }
  isCorrect() {
    for (var i=0; i < this.state.cells.length; i++) {
      var cell = this.state.cells[i];
      var fill = cell.get('fill');
      var entry = cell.get('entry');

      if (fill !== '#' && (entry !== fill && entry !== fill.charAt(0)))
        return false;
    }
    return true;
  }
  resetPrompt() {
    this.setState({reset_prompt: true});
  }
  reset() {
    for (var i=0; i < this.state.cells.length; i++) {
      var cell = this.state.cells[i];
      if (!cell.isBlack())
        cell.setState({'entry': ' '});
    }
    this.setState({cells: this.state.cells.slice(), reset_prompt: false});
    this.saveStoredData();
    this.state.timer.setState({elapsed: 0, stopped: false});
    this.setState({timer: this.state.timer});
  }
  processKeyCode(keyCode: number, shift: boolean)
  {
    // A-Z
    if (keyCode != 0x3d && keyCode >= 0x30 && keyCode <= 0x5a) {
      var ch = String.fromCharCode(keyCode)
      this.type(ch.toUpperCase());
      return true;
    }

    switch (keyCode) {
      case 0x5:
        // synthetic soft-key for toggle numeric
        this.setState({show_numeric_keys: !this.state.show_numeric_keys});
        return true;
      case 0x6:
        // synthetic soft-key for IJ
        const cell = this.state.cells[this.state.activecell];
        cell.setState({ entry: "IJ" });
        this.navNext();
        return true;
      case 0x8:
        this.backspace();
        return true;
      case 0x9:
      case 0x0d:
        if (!shift)
          this.navNextClue();
        else
          this.navPrevClue();
        return true;
      case 0x3d:    //equal sign in Firefox
      case 0xbb:    //equal sign
        if (shift)
          this.startRebus();
        return true;
      case 0x6b:    //numpad add
        this.startRebus();
        return true;
      case 0x20:
        this.switchDir();
        return true;
      case 0x23:
        this.navEnd();
        return true;
      case 0x24:
        this.navStart();
        return true;
      case 0x25:
        this.navLeft();
        return true;
      case 0x26:
        this.navUp();
        return true;
      case 0x27:
        this.navRight();
        return true;
      case 0x28:
        this.navDown();
        return true;
      case 0x2e:
        this.del();
        return true;
      case 0x74:
        this.resetPrompt();
        return true;
      default:
        return false;
    }
  }
  handleKeyDown(e: KeyboardEvent) {
    if (e.ctrlKey || e.altKey)
      return;
    
    //handle keyboard shortcuts
    if (e.shiftKey) {
      switch (e.key) {
        //toggle dates (puzzle list) dropdown
        case "D":
          this.setState({ isDropdownXwordPuzzleListOpen: !this.state.isDropdownXwordPuzzleListOpen })
          this.setState({ isRevealTypeOpen: false })
          e.preventDefault()
          return
          
        //check
        case "C":
          this.check()
          e.preventDefault()
          return
    
        //reveal
        case "R":
          this.reveal()
          e.preventDefault()
          return

        //reveal type
        case "L":   // L because the first option Letter starts with an L
          this.setState({ isRevealTypeOpen: !this.state.isRevealTypeOpen })
          this.setState({ isDropdownXwordPuzzleListOpen: false })
          e.preventDefault()
          return
      
        //print
        case "P":
          this.printButtonRef.current?.open()
          e.preventDefault()
          return

        //soft keyboard
        case "K":
          this.toggleKeyboard()
          e.preventDefault()
          return

        //help
        case "?":
        case "H":
          this.helpButtonRef.current?.open()
          e.preventDefault()
          return

        //timer
        case "T":
          this.timerButtonRef.current?.handleClick()
          e.preventDefault()
          return
      }
    }

    const isDropdownOpen = this.state.isDropdownXwordPuzzleListOpen || this.state.isRevealTypeOpen
    const isModalOpen = document.activeElement?.classList.contains("modal")

    if (!isDropdownOpen && !isModalOpen) {
      if (this.state.direction === 'A' && (e.keyCode === 0x26 || e.keyCode === 0x28)) {
        this.selectCell(this.state.activecell, 'D');
        e.preventDefault();
        return;
      }
      if (this.state.direction === 'D' && (e.keyCode === 0x25 || e.keyCode === 0x27)) {
        this.selectCell(this.state.activecell, 'A');
        e.preventDefault();
        return;
      }
      if (this.processKeyCode(e.keyCode, e.shiftKey)) {
        e.preventDefault();
      }

    }
  }
  handleClick(i: number) {
    if (this.state.activecell === i) {
      this.switchDir();
    } else {
      this.selectCell(i, this.state.direction);
    }
  }
  puzzleLoaded(url: string, puz: Object) {
    var grid = puz.grid;
    var flags = puz.flags;
    var maxx = grid[0].length;
    var maxy = grid.length;
    var i;
    var title = i18n.t("mainUntitled");
    var author = i18n.t("mainUnknown");
    var notes = null;

    for (i=0; i < puz.headers.length; i++) {
      var [header, value] = puz.headers[i];
      if (header === 'Title') {
        title = value;
      } else if (header === 'Creator' || header === 'Author') {
        author = value;
      } else if (header === 'Notes') {
        notes = value;
      }
    }

    var cells = Array(maxx * maxy);
    var cell_to_clue_table = Array(maxx * maxy);

    var number_index = [];
    for (var y = 0; y < maxy; y++) {
      for (var x = 0; x < maxx; x++) {
        var fill = grid[y][x];
        var is_black = fill === '#';
        var number = 0;
        var start_of_xslot = (!is_black &&
                              (x === 0 || grid[y][x-1] === '#') &&
                              (x + 1 < maxx && grid[y][x+1] !== '#'));
        var start_of_yslot = (!is_black &&
                              (y === 0 || grid[y-1][x] === '#') &&
                              (y + 1 < maxy && grid[y+1][x] !== '#'));

        if (start_of_xslot || start_of_yslot) {
          number_index.push([x,y]);
          number = number_index.length;
        }
        var circled = false;
        var hidden = false;
        let greyed = false;
        if (flags) {
          circled = !!(flags[y][x] & puz.FLAGS.CIRCLED);
          hidden = !!(flags[y][x] & puz.FLAGS.HIDDEN);
          greyed = !!(flags[y][x] & puz.FLAGS.GREYED);
        }
        cells[y * maxx + x] = new XwordCell({
          fill,
          number,
          active: false,
          circled,
          hidden,
          greyed
        });
        cell_to_clue_table[y * maxx + x] = [null, null];
      }
    }

    var clues = [];
    var clue_to_cell_table = [];

    for (i=0; i < puz.clues.length; i++) {
      var [type, cluestr, answer] = puz.clues[i];
      var [dir, num] = type;
      var clue = new XwordClue({
        'index': i, 'direction': dir, 'number': num, 'clue': cluestr,
        'answer': answer});
      clues.push(clue);

      // clue_to_cell table: index into clues[] has the corresponding
      // cell id
      var xy = number_index[num - 1];
      clue_to_cell_table[i] = xy[1] * maxx + xy[0];

      // set up cell_to_clue_table: indexed by cell id, each entry
      // has a two element array (across, down) which contains the
      // index into clues[].  Iterate over answer in the direction
      // of the clue to set all cells making up the answer
      var ind = 0, xincr = 0, yincr = 0;
      if (dir === 'A') {
        xincr = 1;
      } else {
        ind = 1; yincr = 1;
      }
      [x, y] = xy;
      for (var j = 0; y < maxy && x < maxx; j++) {
        var cell = y * maxx + x;
        if (grid[y][x] === '#')
          break;
        cell_to_clue_table[cell][ind] = i;
        x += xincr; y += yincr;
      }
    }
    this.setState({
      'title': title, 'author': author, 'notes': notes,
      'width': maxx, 'height': maxy, 'cells': cells, 'clues': clues,
      'clue_to_cell_table': clue_to_cell_table,
      'cell_to_clue_table': cell_to_clue_table,
      puzzle_id: puz.puzzle_id
    });
    this.loadStoredData();
    this.selectClue(clues[0], true);
    this.resizeScrollPane();
  }
  resizeScrollPane()
  {
    // set cluelist to match grid height
    var gridelem = document.getElementById("xwordjs-grid");
    var inner_gridelem = document.getElementById("xwordjs-grid-inner");
    var cluediv = document.getElementById("xwordjs-cluelist-container");
    var cluelist = document.getElementsByClassName("xwordjs-cluelist");
    if (!gridelem || !inner_gridelem)
      return;

    var gridHeight = parseInt(window.getComputedStyle(gridelem).getPropertyValue("height"), 10);
    var innerGridHeight = parseInt(window.getComputedStyle(inner_gridelem).getPropertyValue("height"), 10);

    gridHeight = Math.min(gridHeight, innerGridHeight);
    gridHeight += "px";

    if (cluediv) {
      cluediv.style.height = gridHeight;
    }

    for (var i = 0; i < cluelist.length; i++) {
        var e = cluelist[i];
        var newheight = String(parseInt(gridHeight, 10) / 2 - 25) + "px";
        e.style.height = newheight;
    }
  }
  saveStoredData()
  {
    var key = this.state.cells.map((x) => x.state.fill).join("");
    var data = {
      entries: this.state.cells.map((x) => x.state.entry),
      elapsed: this.state.timer.get('elapsed')
    };
    // avoid a race condition when first starting up
    if (!data.elapsed)
      return;
    localStorage.setItem(key, JSON.stringify(data));
  }
  readStoredData()
  {
    var key = this.state.cells.map((x) => x.state.fill).join("");
    var data = localStorage.getItem(key);
    if (!data)
      return null;

    return JSON.parse(data);
  }
  loadStoredData()
  {
    var data = this.readStoredData()
    if (!data)
      return;

    var entries = data.entries;
    var elapsed = data.elapsed;
    for (var i=0; i < entries.length; i++) {
      this.state.cells[i].setState({entry: entries[i]});
    }
    this.setState({modified: true})
    this.state.timer.setState({elapsed: elapsed});
    this.setState({cells: this.state.cells, timer: this.state.timer});
  }
  highlightClue(clue: XwordClue, active: boolean)
  {
    var cluenum = clue.get('index');
    var cind = this.state.clue_to_cell_table[cluenum];
    var [x, y] = this.cellPos(cind);

    var x_incr = clue.get('direction') === 'A' ? 1 : 0;
    var y_incr = !x_incr;

    for (; x < this.state.width && y < this.state.height; ) {
      var cell = this.state.cells[this.state.width * y + x];
      if (cell.isBlack())
        break;

      cell.setState({"active": active});
      x += x_incr;
      y += y_incr;
    }
  }
  selectCell(cell_id: number, direction: string, initial: ?boolean)
  {
    var cell = this.state.cells[cell_id];

    if (cell.isBlack())
      return;

    var newclues = this.state.clues.slice();
    var newcells = this.state.cells.slice();

    // unselect existing selected cell and crosses
    var oldcell_id = this.state.activecell;
    var old_dind = (this.state.direction === 'A') ? 0 : 1;
    var oldclue = this.state.clues[this.state.cell_to_clue_table[oldcell_id][old_dind]];
    var oldcross = this.state.clues[this.state.cell_to_clue_table[oldcell_id][1 - old_dind]];
    var oldcell = this.state.cells[oldcell_id];

    var dind = (direction === 'A') ? 0 : 1;
    var clue = this.state.clues[this.state.cell_to_clue_table[cell_id][dind]];
    var cross = this.state.clues[this.state.cell_to_clue_table[cell_id][1 - dind]];

    var e;

    if (initial || oldcross !== cross) {
      if (oldcross)
        oldcross.setState({"crossActive": false});
      if (cross) {
        cross.setState({"crossActive": true});
        e = document.getElementById("clue_" + cross.get('index'));
        if (e)
          scrollIntoViewIfNeeded(e);
      }
    }

    if (initial || oldclue !== clue) {

      if (oldclue) {
        oldclue.setState({"active": false});
        this.highlightClue(oldclue, false);
      }
      if (clue) {
        clue.setState({"active": true});
        this.highlightClue(clue, true);
        e = document.getElementById("clue_" + clue.get('index'));
        if (e)
          scrollIntoViewIfNeeded(e);
      }
    }

    if (initial || oldcell_id !== cell_id) {
      oldcell.setState({focus: false});
      cell.setState({focus: true});
    }
    e = document.getElementById("cell_" + cell_id);
    if (e)
      scrollIntoViewIfNeeded(e);
    this.setState({'clues': newclues, 'cells': newcells, 'activecell': cell_id, 'direction': direction, rebus: false});
  }
  reveal()
  {
    if (this.state.reveal_opt == "letter") {
      this.revealCell();
    } else if (this.state.reveal_opt == "word") {
      this.revealClue();
    } else {
      this.revealAll();
    }
  }
  revealCell()
  {
    var cell = this.state.cells[this.state.activecell];
    cell.setState({'entry': cell.get('fill')});
    this.setState({'cells': this.state.cells.slice()});
  }
  revealClue()
  {
    var dind = (this.state.direction === 'A') ? 0 : 1;
    var cur_cell_id = this.state.activecell;
    var clue_id = this.state.cell_to_clue_table[cur_cell_id][dind];

    var cind = this.state.clue_to_cell_table[clue_id];
    var [x, y] = this.cellPos(cind);

    var x_incr = !dind;
    var y_incr = !x_incr;
    var cell;

    for (; x < this.state.width && y < this.state.height; ) {
      cell = this.state.cells[this.state.width * y + x];
      if (cell.isBlack())
        break;

      cell.setState({"entry": cell.get('fill')});
      x += x_incr;
      y += y_incr;
    }

    cell = this.state.cells[this.state.activecell];
    cell.setState({'entry': cell.get('fill')});
    this.setState({'cells': this.state.cells.slice()});
  }
  selectClue(clue: XwordClue, initial: ?boolean)
  {
    var cluenum = clue.get('index');

    // set first empty cell in this clue as active
    var cell = this.state.clue_to_cell_table[cluenum];
    var [start_x, start_y] = this.cellPos(cell);
    var empty_cell = this.findNextEmptyCell(clue.get('direction'),
        start_x, start_y);
    if (empty_cell != null)
      cell = empty_cell;

    this.selectCell(cell, clue.get('direction'), initial);
  }
  check() {
    if (this.state.reveal_opt == "letter") {
      this.checkCell();
    } else if (this.state.reveal_opt == "word") {
      this.checkClue();
    } else {
      this.checkAll();
    }
  }
  checkCell() {
    var cell = this.state.cells[this.state.activecell];
    if (cell.get('entry') !== ' ' &&
        cell.get('entry') !== cell.get('fill')) {
      cell.setState({incorrect: true});
    } else {
      cell.setState({incorrect: false});
    }
    this.setState({'cells': this.state.cells.slice()});
  }
  checkClue() {
    var dind = (this.state.direction === 'A') ? 0 : 1;
    var cur_cell_id = this.state.activecell;
    var clue_id = this.state.cell_to_clue_table[cur_cell_id][dind];

    var cind = this.state.clue_to_cell_table[clue_id];
    var [x, y] = this.cellPos(cind);

    var x_incr = !dind;
    var y_incr = !x_incr;
    var cell;

    for (; x < this.state.width && y < this.state.height; ) {
      cell = this.state.cells[this.state.width * y + x];
      if (cell.isBlack())
        break;

      if (cell.get('entry') !== ' ' &&
          cell.get('entry') !== cell.get('fill')) {
        cell.setState({incorrect: true});
      } else {
        cell.setState({incorrect: false});
      }
      x += x_incr;
      y += y_incr;
    }

    cell = this.state.cells[this.state.activecell];
    cell.setState({'entry': cell.get('fill')});
    this.setState({'cells': this.state.cells.slice()});
  }
  checkAll() {
    for (var i=0; i < this.state.cells.length; i++) {
      var cell = this.state.cells[i];
      if (!cell.isBlack()) {
        if (cell.get('entry') !== ' ' &&
            cell.get('entry') !== cell.get('fill')) {
          cell.setState({incorrect: true});
        } else {
          cell.setState({incorrect: false});
        }
      }
    }
    var newcells = this.state.cells.slice();
    this.setState({'cells': newcells});
  }
  revealAll() {
    for (var i=0; i < this.state.cells.length; i++) {
      var cell = this.state.cells[i];
      if (!cell.isBlack())
        cell.setState({'entry': cell.get('fill')});
    }
    var newcells = this.state.cells.slice();
    this.setState({'cells': newcells});
  }
  updateTimer(state: Object) {
    if (state.stopped)
      return;

      if (this.isCorrect()) {
      state.stopped = true;
      this.setState({show_completed: true});
    }
    this.saveStoredData();
    this.state.timer.setState(state);
    this.setState({'timer': this.state.timer});

    if (!this.state.solutionId)
      return;

    var entries = [];
    for (var i=0; i < this.state.cells.length; i++) {
      var cell = this.state.cells[i];
      entries.push({'Version': cell.get('version'), 'Value': cell.get('entry')});
    }
    if (this.state.modified) {
      // $FlowFixMe
      this.state.server.sendSolution(this.state.solutionId,
                                     this.state.version, entries);
      this.setState({modified: false});
    }
  }
  toggleKeyboard()
  {
    this.setState({show_keyboard: !this.state.show_keyboard});
    window.setTimeout(this.resizeScrollPane, 0);
  }
  startRebus() {
    this.setState({rebus: true});
  }
  componentDidMount() {
    var self = this;
    window.addEventListener("keydown", this.onKeyDown);
    window.addEventListener("resize", this.onResize);

    if (this.state.show_dates_dropdown) {
      //show dates dropdown to allow user select a date
      this.state.server.getPuzzleList().then(function(x) {
        // var items = x.trim().split("\r\n");
        // var items = x.trim().split("\n");
        var items = x.trim().split(/\r\n|\r|\n/);
        self.setState({available_puzzles: items});
  
        if (self.props.serverId && self.state.available_puzzles.indexOf(self.props.serverId) >= 0) {
          self.loadServerPuzzle(self.props.serverId);
        }
      });
    } else {
      //use settings from querystring parameters
      //  example querystring: ?date=210304
      const params = getQueryParams();
      if (params) {
        let date = params.date;
        if (!date) {
          date = formatDateYYMMDD(new Date());
        }
        this.setState({ available_puzzles: [date] });

        //modified version of loadServerPuzzle with fallback if no puzzle available for given date
        this.state.server.getPuzzle(date).then(function (data) {
          const puz = new Acpt(data);

          if (process.env.REACT_APP_GRID_DYNAMIC?.toLowerCase() === "true") {
            if (Number.isInteger(puz?.width)) {
              Layout.gridWidth = puz.width
            }
            if (Number.isInteger(puz?.height)) {
              Layout.gridHeight = puz.height
            }
          }

          if ((process.env.REACT_APP_GRID_DYNAMIC?.toLowerCase() === "true") || (puz.width == process.env.REACT_APP_GRID_WIDTH)) {
            //fetched puzzle with correct dimensions
            self.puzzleLoaded(date, puz);
          } else {
            //fallback to original dropdown algorithm
            self.state.server.getPuzzleList().then(function(x) {
              // const items = x.trim().split("\n");
              const items = x.trim().split(/\r\n|\r|\n/);
              if (items.length > 0) {
                self.setState({available_puzzles: items});
                self.loadServerPuzzle(items[0]);
              }
            });
          };
        });
      }
    }
  }
  componentWillUnmount() {
    window.removeEventListener("keydown", this.onKeyDown);
    window.removeEventListener("resize", this.onResize);
  }

  render() {
    var self = this;
    if (this.state.cells.length === 0) {
      return <Loading/>;
    }

    const renderXwordPuzzleList = (load) => {
      const formatDate = (datestr) => datestr.substr(2, 2) + "/" + datestr.substr(4, 2) + "/" + datestr.substr(0, 2);
      const items = this.state.available_puzzles
      const menu_items = [];
      let title = i18n.t("mainSelectPuzzle");
      for (let i=0; i < items.length; i++) {
        if (this.props.serverId === items[i]) {
          title = formatDate(items[i]);
        }
        menu_items.push(
          <Dropdown.Item eventKey={i} key={i} onClick={() => load(items[i])}>{formatDate(items[i])}</Dropdown.Item>
        );
      }
    
      return (
        <OverlayTrigger delay={TOOLTIP_DELAY} placement="right" overlay={<Tooltip placement="bottom" className="in" id="tooltip-bottom">{i18n.t("xwordPuzzleListTooltip")}</Tooltip>}>
          <DropdownButton 
            id="dropdown-xwordpuzzlelist" 
            className={"xwordjs-puzzle-list"} 
            variant="light"
            title={title} 
            size="sm"
            focusFirstItemOnShow={true}
            show={this.state.isDropdownXwordPuzzleListOpen}
            onToggle={isDropdownXwordPuzzleListOpen => {
              this.setState({ isDropdownXwordPuzzleListOpen })
              document.activeElement?.blur()
            }}
          >
            {menu_items}
          </DropdownButton>
        </OverlayTrigger>
      )
    }

    const renderRevealList = (onClick) => {
      let title;
      switch (this.state.reveal_opt) {
        default:
        case "letter":
          title = i18n.t("revealLetter");
          break;
        case "word":
          title = i18n.t("revealWord");
          break;
        case "all":
          title = i18n.t("revealAll");
          break;
      }

      return (
        <OverlayTrigger delay={TOOLTIP_DELAY} placement="right" overlay={<Tooltip placement="bottom" className="in" id="tooltip-bottom">{i18n.t("revealTypeTooltip")}</Tooltip>}>
          <DropdownButton
            id="dropdown-reveallist" 
            variant="light" 
            title={title} 
            size="sm"
            focusFirstItemOnShow={true}
            show={this.state.isRevealTypeOpen}
            onToggle={isRevealTypeOpen => {
              this.setState({ isRevealTypeOpen })
              document.activeElement?.blur()
            }}
          >
            <Dropdown.Item eventKey="2" onClick={() => onClick("letter")}>{i18n.t("revealLetter")}</Dropdown.Item>
            <Dropdown.Item eventKey="3" onClick={() => onClick("word")}>{i18n.t("revealWord")}</Dropdown.Item>
            <Dropdown.Item eventKey="4" onClick={() => onClick("all")}>{i18n.t("revealAll")}</Dropdown.Item>
          </DropdownButton>
        </OverlayTrigger>
      );
    }

    return (
      <div className="XwordMain">
        <div className="xwordjs-vertical-container">
          <Modal show={this.state.reset_prompt} onHide={() => this.setState({reset_prompt: false})}>
            <Modal.Header closeButton>
              <Modal.Title>{i18n.t("resetTitle")}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <p>{i18n.t("resetMessage")}</p>
            </Modal.Body>
            <Modal.Footer>
              <ButtonGroup>
                <Button onClick={() => this.reset()}>{i18n.t("resetButton")}</Button>
                <Button onClick={() => this.setState({reset_prompt: false})}>{i18n.t("resetCancel")}</Button>
              </ButtonGroup>
            </Modal.Footer>
          </Modal>
          <Modal show={this.state.show_completed} onHide={() => this.setState({show_completed: false})}>
            <Modal.Header closeButton>
              <Modal.Title>{i18n.t("completedTitle")}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <p>{i18n.t("completedMessage")}</p>
            </Modal.Body>
            <Modal.Footer>
              <Button onClick={() => this.setState({show_completed: false})}>{i18n.t("completedButton")}</Button>
            </Modal.Footer>
          </Modal>
          <div className="xwordjs-timer-bar">
            <ButtonToolbar>
              { this.state.show_dates_dropdown && 
                <ButtonGroup className="mr-3">
                  { renderXwordPuzzleList((id) => {
                    self.props.history.push("/s/" + id);
                    self.loadServerPuzzle(id);
                  })}
                </ButtonGroup>
              }

              <ButtonGroup className="mr-3">
                <CheckButton onClick={() => this.check()}/>
                <RevealButton onClick={() => this.reveal()}/>
                { renderRevealList((reveal_opt) => this.setState({ reveal_opt })) }
              </ButtonGroup>

              <ButtonGroup className="mr-3">
                { Layout.isBigGrid &&
                  <PrintButton ref={this.printButtonRef} onSelect={(type) => this.print(this.state.puzzle_id, type)}/>
                }
                <MobileKeyboardButton onClick={() => this.toggleKeyboard()} active={this.state.show_keyboard}/>
                <HelpButton ref={this.helpButtonRef} />
              </ButtonGroup>

              <ButtonGroup>
                <Timer ref={this.timerButtonRef} value={this.state.timer} onChange={(x) => this.updateTimer(x)}/>
              </ButtonGroup>
            </ButtonToolbar>
          </div>
          <div className="xwordjs-topbar">
            <Title title={this.state.title} author={this.state.author}/>
          </div>
          <ClueBar value={this.state.clues}/>
          <div className="xwordjs-container">
            <div className="xwordjs-grid" id="xwordjs-grid">
              <Grid height={this.state.height} width={this.state.width} cells={this.state.cells} handleClick={(x) => this.handleClick(x)}/>
              <Credits width={this.state.width} />
            </div>
            <Clues selectClue={(i) => this.selectClue(i)} value={this.state.clues}/>
          </div>
          <div>
            <Notes notes={this.state.notes}/>
          </div>
          <MobileKeyboard onClick={(code) => this.processKeyCode(code, false)} hidden={!this.state.show_keyboard} show_numeric_keys={this.state.show_numeric_keys}/>
        </div>
      </div>
    );
  }
}

const CheckButton = (props) => (
  <OverlayTrigger delay={TOOLTIP_DELAY} placement="bottom" overlay={<Tooltip placement="bottom" className="in" id="tooltip-bottom">{i18n.t("checkTooltip")}</Tooltip>}>
    <Button variant="light" size="sm" onClick={props.onClick}>
      <i className="icon fa fa-check" />
    </Button>
  </OverlayTrigger>
);

const RevealButton = (props) => (
  <OverlayTrigger delay={TOOLTIP_DELAY} placement="bottom" overlay={<Tooltip placement="bottom" className="in" id="tooltip-bottom">{i18n.t("revealTooltip")}</Tooltip>}>
    <Button variant="light" size="sm" onClick={props.onClick}>
      <i className="icon fa fa-eye" />
    </Button>
  </OverlayTrigger>
);

const Credits = (props) => {
  const theme = process.env.REACT_APP_THEME
  const renderSpans = () => {
    if (theme == "ST") {
      return <>
        <span>Distributed by The New York Times Syndicate</span>
        <span>Powered by <a href="https://www.pzzl.com" target="_blank">PZZL.com</a></span>
      </>
    } else {
      return <>
        <span/>
        <span>© <a href="https://www.pzzl.com" target="_blank">PZZL.com</a></span>
      </>
    }
  }

  return (
    <div style={{
      display: "flex",
      position: "relative", 
      width: process.env.REACT_APP_GRID_DYNAMIC?.toLowerCase() === "true" ? Layout.boardWidth : props.width * Layout.cellSize,
      top: 0, 
      marginBottom: 10,
      // textAlign: "end", 
      justifyContent: "space-between",
      fontSize: theme == "ST" ? 11 : 13
    }}>
      { renderSpans()}
    </div>
  )
}

const Notes = (props) => {
  if (!props.notes) {
    return <span/>;
  }
  return <Accordion>
    <Card>
      <Card.Header>
        <Accordion.Toggle as={Button} variant="link" eventKey="0">
          {i18n.t("mainNotes")}
        </Accordion.Toggle>
      </Card.Header>
      <Accordion.Collapse eventKey="0">
        <Card.Body>
          {props.notes}
        </Card.Body>
      </Accordion.Collapse>
    </Card>
  </Accordion>
};

class XwordLoadLatest extends Component {
  state: {
    available_puzzles: Array<string>
  };

  constructor() {
    super();
    this.state = {
      available_puzzles: [],
      show_dates_dropdown: process.env.REACT_APP_ENABLE_DATES_DROPDOWN ? process.env.REACT_APP_ENABLE_DATES_DROPDOWN.toLowerCase() === 'true' : true,
    }
  }
  componentDidMount() {
    var self = this;
    if (this.state.show_dates_dropdown) {
      //show dates dropdown to allow user select a date
      new Server().getPuzzleList().then(function(x) {
        // var items = x.trim().split("\r\n");
        // var items = x.trim().split("\n");
        var items = x.trim().split(/\r\n|\r|\n/);
        self.setState({available_puzzles: items});
      });
    } else {
      //use settings from querystring parameters
      //  example querystring: ?date=210304
      const params = getQueryParams();
      if (params) {
        let date = params.date;
        if (!date) {
          date = formatDateYYMMDD(new Date());
        }
        this.setState({ available_puzzles: [date] });
      } else {
        console.warn("Missing query params!")
      }
    }
  }
  render() {
    if (!this.state.available_puzzles.length) {
      return <Loading/>;
    }
    return <Redirect to={"/s/" + this.state.available_puzzles[0]}/>;
  }
}

function XwordLoadFile(props) {
  return (
    <XwordSolver filename={props.match.params.name}/>
  );
}

function XwordLoadServer(props) {
  return (
    <XwordSolver serverId={props.match.params.id} history={props.history}/>
  );
}

function XwordMainPanel() {
  return (
    <Switch>
      <Route exact path="/" component={XwordLoadLatest}/>
      <Route path="/file/:name" component={XwordLoadFile}/>
      <Route path="/s/:id" component={XwordLoadServer}/>
    </Switch>
  );
}

function XwordMain() {
  return (
    <div>
      <XwordMainPanel />
    </div>
  );
}


export default XwordMain;
